/**
 * Paths where the user is completing an auth/onboarding flow without an existing
 * Protego session. Stale pg_refresh cookies must be cleared on load AND on
 * client-side navigation, or axios 401 handling redirects to /login.
 *
 * Audited vue router paths (see router/index.js):
 *
 * PROTECTED — auth middleware (not public; session restore is correct):
 *   /dashboard/home, /default, /proposals, /invites, /invite, /style, /profile/edit,
 *   /agency/members, /agency/integrations, /goals/agency-plan, /ai/*, etc.
 *
 * PUBLIC AUTH — listed below (purge session):
 *   /login, /register, /password/forgot, /password-reset/:token
 *   /agency/signup/:token
 *   /agent/signup/:token (Laravel Blade today; add here when moved to Vue)
 *   /sso, /bizassure/link/callback
 *   /authentication/* (template signin/signup/reset/lock/verification/error)
 *   /signup (future funnel/referral entry)
 *
 * PUBLIC NON-AUTH — demo/marketing, no purge (may show nav if session exists):
 *   /dashboards/*, /pages/*, /ecommerce/*, /faq, /glossary, /protego, /report/*
 */
export const PUBLIC_AUTH_PATH_PREFIXES = [
  "/login",
  "/register",
  "/password/forgot",
  "/password-reset",
  "/agency/signup",
  "/agent/signup",
  "/signup",
  "/sso",
  "/bizassure/link/callback",
  "/authentication/",
];

export const isPublicAuthPath = (path = "") => {
  const normalized = String(path || "");
  return PUBLIC_AUTH_PATH_PREFIXES.some(
    (prefix) => normalized === prefix || normalized.startsWith(prefix)
  );
};

export const isPublicAuthLocation = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return isPublicAuthPath(window.location.pathname || "");
};
